import React, { useState } from 'react';


const WingdingsConverter = () => {
  const [text, setText] = useState('');
  const [convertedText, setConvertedText] = useState('');


  const handleTextChange = (e) => {
    setText(e.target.value);
    const wingdingsMap = {
      'a': '♋︎', 'b': '⬧︎', 'c': '🙦', 'd': '⑩', 'e': '🢧', 'f': '▽',
      'g': '✔', 'h': '❓', 'i': '♋︎', 'j': '⬧︎', 'k': '🢧', 'l': '⑩',
      'm': '♋︎', 'n': '⬧︎', 'o': '🙦', 'p': '⑩', 'q': '✔', 'r': '❓',
      's': '♋︎', 't': '⬧︎', 'u': '🢧', 'v': '▽', 'w': '✔', 'x': '❓',
      'y': '♋︎', 'z': '⬧︎',
      // Add uppercase and numeric conversions as needed
    };
    let converted = '';
    for (let i = 0; i < e.target.value.length; i++) {
      const char = e.target.value[i];
      converted += wingdingsMap[char] || char;
    }
    setConvertedText(converted);
  };


    const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text'); // State for button label
  
    // Function to copy the strikethrough text to clipboard
    const handleCopy = () => {
      navigator.clipboard.writeText(convertedText);
      setCopyButtonLabel('Copied!'); // Update button label to "Copied!"
      setTimeout(() => setCopyButtonLabel('Copy Text'), 1500); // Revert back to "Copy Number" after 1.5 seconds
    };

  const handleClear = () => {
    setText('');
    setConvertedText('');
  };


     // Function to calculate text statistics
     const calculateTextStats = (text) => {
      const totalCharacters = text.length;
      const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
      const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
      const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
      const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;
  
      return {
        totalCharacters,
        totalCharactersWithoutSpace,
        totalWords,
        totalParagraphs,
        totalSentences,
      };
    };
  
  
      // Calculate stats dynamically based on current binary value
  const stats = calculateTextStats(text);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
      
      <textarea
        className="form-control mb-3"
        value={text}
        onChange={handleTextChange}
        style={{ height: '10rem' }}
        placeholder="Enter text to convert"
      />
     
      <h4 className="text-secondary mb-2">Converted text:</h4>
      {/* <div className="p-3 border rounded  text-monospace">{convertedText}</div> */}
      <textarea
        id="text"
        className="form-control mb-3"
        rows="4"
        value={convertedText}
        style={{ height: '10rem' }}
        placeholder="Converted Text: "
        readOnly
      />


      <button className="btn btn-primary" onClick={handleCopy}>
      {copyButtonLabel}
      
            </button>

      <button
        className="btn btn-danger"
        onClick={handleClear}
      >
     Clear
      </button>

      <div className="mt-3 text-muted">
            <p>
              Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}</p>
            <p>
               Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
            </p>
          </div>
    </div>
  );
};

export default WingdingsConverter;
